(function () {
  const moveDownloadIntoSwym = () => {
    const target = document.querySelector("#swym-atw-button-container");
    if (!target) return false;

    const source = document.querySelector(".download-only-div");
    if (!source) return false;

    if (!target.contains(source)) {
      target.appendChild(source);
    }

    return true;
  };

  if (moveDownloadIntoSwym()) return;

  const observer = new MutationObserver(() => {
    if (moveDownloadIntoSwym()) observer.disconnect();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();


(function () {
  const normalizeText = (el) => {
    if (!el) return false;

    const text = el.textContent.trim();

    if (text === "ADD TO WISHLIST") {
      el.textContent = "Add To Wishlist";
      return true;
    }

    if (text === "ADDED TO WISHLIST") {
      el.textContent = "Added To Wishlist";
      return true;
    }

    return false;
  };

  const run = () => {
    const el = document.querySelector("#swym-atw-pdp-button-text");
    if (!el) return false;
    return normalizeText(el);
  };

  // run immediately
  if (run()) return;

  // watch for Swym async updates
  const observer = new MutationObserver(() => run());

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();